<template>
  <div class="full-reason-select-content">
    <div
      class="input para-search"
      v-for="(val, index) in labelOrigin.result"
      :key="val.id"
      :style="{ marginLeft: '4px' }"
    >
      <configureRemoteSelect
        :ref="labelOrigin.key"
        :item="val"
        :type="labelOrigin.key"
        :checkAllName="labelOrigin.checkAllName"
        @valueChange="remoteSelectChange"
        :style="{ width: '500px', margin: '2px 7px 2px 0' }"
      />
      <el-tooltip ref="toolFirstTip" effect="dark" content="添加条件" placement="top">
        <span class="operation" @click="labelOrigin.addRes()"><i class="el-icon-circle-plus-outline"></i></span>
      </el-tooltip>
      <span class="operation" v-if="showDelIcon" @click="labelOrigin.removeRes(index)"
        ><i class="el-icon-remove-outline"></i
      ></span>
    </div>

    <div class="text-group-type" v-if="labelOrigin.result && labelOrigin.result.length">
      <div slot="reference" class="group-type-btn">
        <span @click="labelOrigin.type = 'and'" class="group-text" :class="[labelOrigin.type === 'and' ? 'active' : '']"
          >且</span
        >
        <span @click="labelOrigin.type = 'or'" class="group-text" :class="[labelOrigin.type === 'or' ? 'active' : '']"
          >或</span
        >
      </div>
    </div>
    <div class="line">
      <span class="line-item line-item-top"></span>
      <span class="line-item line-item-bottom"></span>
    </div>
  </div>
</template>

<script>
import configureRemoteSelect from '@/components/configureRemoteSelect';

export default {
  components: {
    configureRemoteSelect
  },
  data() {
    return {
      labelOrigin: {}
    };
  },
  props: {
    label: {
      type: Object,
      required: true
    }
  },
  watch: {
    labelOrigin: {
      handler(val) {
        this.$emit('updateLabel', val);
      },
      deep: true
    },
    label: {
      handler(val) {
        this.labelOrigin = val;
      },
      deep: true
    }
  },
  computed: {
    showDelIcon() {
      return this.labelOrigin.result.length > 2;
    }
  },
  mounted() {
    this.labelOrigin = this.label;
  },
  methods: {
    remoteSelectChange(item, value, showValue) {
      item.value = value;
      item.showValue = showValue;
    }
  }
};
</script>

<style lang="less" scoped>
.full-reason-select-content {
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  margin: 4px 0;

  .text-group-type {
    position: absolute;
    left: -18px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    user-select: none;

    .group-type-btn {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .group-text {
        color: #999999;
        background-color: #f5f5f5;
        line-height: 20px;
        padding: 0 2px;

        &.active {
          color: #e42626;
          background-color: #ffeaea;
        }
      }

      &.not-allowed {
        cursor: not-allowed;
      }
    }
  }

  .line {
    display: inline-block;
    background: #ddd;
    width: 1px;
    height: 100%;
    position: absolute;
    left: -11px;
    top: 50%;
    transform: translateY(-50%);
    .line-item {
      contain: '';
      display: block;
      height: 1px;
      width: 10px;
      background: #ddd;
      position: relative;
    }
    .line-item-top {
      position: absolute;

      top: 0;
    }
    .line-item-bottom {
      position: absolute;
      bottom: 0;
    }
  }
}

.operation {
  position: relative;
  top: 2px;
  font-size: 20px;
  color: #a0acc0;
  margin-right: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/fullReasonSelect/index.vue